
// src/connects/group-remind-panel.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'
import {fetchDiary, putDiaryReportReport} from "../actions/diary-report";
import moment from "moment";

export const mapStateToProps = (state, ownProps)=> {

  let weeklyReportStartDate = null;
  if (state.diaryReport.weeklyReportStartDate) {
    weeklyReportStartDate = moment(state.diaryReport.weeklyReportStartDate).toDate()
  }

  let monthlyReportStartDate = null;
  if (state.diaryReport.monthlyReportStartDate) {
    monthlyReportStartDate = moment(state.diaryReport.monthlyReportStartDate).toDate()
  }
  return {
    group: getArray('group_id', state.groups.items, ownProps.group.group_id),
    isWeeklyReport: state.diaryReport.isWeeklyReport,
    isMonthlyReport: state.diaryReport.isMonthlyReport,
    weeklyReportStartDate: weeklyReportStartDate,
    monthlyReportStartDate: monthlyReportStartDate,
    inputDiaryUserCount: state.diaryReport.inputDiaryUserCount,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: (props)=> {
      if(props.group){
        dispatch(actions.fetchDiary(props.group.group_id))
      }
    },
    updateIsWeeklyReport: (props, value)=> {
      dispatch(actions.putDiaryReportReport(props.group.group_id,
        value,
        props.isMonthlyReport,
        formatDate(props.weeklyReportStartDate),
        formatDate(props.monthlyReportStartDate),
        props.inputDiaryUserCount
      ))
      dispatch(emitAlertMessage({ message: 'label:レポート設定を更新しました' }, 'inputSuccess'))
    },
    updateIsMonthlyReport: (props, value)=> {
      dispatch(actions.putDiaryReportReport(props.group.group_id,
        props.isWeeklyReport,
        value,
        formatDate(props.weeklyReportStartDate),
        formatDate(props.monthlyReportStartDate),
        props.inputDiaryUserCount
      ))
      dispatch(emitAlertMessage({ message: 'label:レポート設定を更新しました' }, 'inputSuccess'))
    },
    updateWeeklyReportStartDate: (props, value)=> {
      dispatch(actions.putDiaryReportReport(props.group.group_id,
        props.isWeeklyReport,
        props.isMonthlyReport,
        formatDate(value),
        formatDate(props.monthlyReportStartDate),
        props.inputDiaryUserCount
      ))
    },
    updateMonthlyReportStartDate: (props, value)=> {
      dispatch(actions.putDiaryReportReport(props.group.group_id,
        props.isWeeklyReport,
        props.isMonthlyReport,
        formatDate(props.weeklyReportStartDate),
        formatDate(value),
        props.inputDiaryUserCount
      ))
    },
    updateInputDiaryUserCount: (props, value)=> {
      dispatch(actions.putDiaryReportReport(props.group.group_id,
        props.isWeeklyReport,
        props.isMonthlyReport,
        formatDate(props.weeklyReportStartDate),
        formatDate(props.monthlyReportStartDate),
        value
      ))
    },
  }
}

function formatDate(value) {
  if (!value) {
    return null
  }
  return moment(value).format('YYYY-MM-DD')
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-report-panel.js